<template>
	<div>
		<common-header navbar-index=2></common-header>
		<robot-banner></robot-banner>
		<div class="container" id="link1">
			<div class="tips mt-5 pt-4 pb-4">
				<a href="javascript:void(0)" @click="toback">行业新闻</a><span class="s1">|</span><span class="s2">"机器人工程"成热门专业，高校加大人工智能人才培养力度</span>
			</div>
			<div class="content_item pt-4 pb-5">
				<div class="pl25 pr25">
					<div class="title mb-4">"机器人工程"成热门专业，高校加大人工智能人才培养力度</div>
					<p class="text">　　一年一度的高考季，填志愿是家长和考生关心的大事， “机器人工程”专业无疑是今年高校填报热门专业之一，教育部在2018年3月21日公布的2017年度高校本科专业备案和审批结果中显示，此次又新增60所高校获批“机器人工程”专业，2017年公布的数据为24所，同比增加了近2倍。</p>
					<p class="text" style="text-align:center"><img alt="" src="../../../assets/img/robot/article/6_1.png" style="height:457px; width:742px"></p>
					<p class="text">在人工智能发展得如火如荼的当下，越来越多高校瞄准人工智能领域，聚焦科技核心人才培养。新增的60所高校名单：</p>
					<p class="text" style="text-align:center">
						<span style="font-family:微软雅黑"><img alt="" src="../../../assets/img/robot/article/6_2.png" style="height:666px; width:507px"><img alt="" src="../../../assets/img/robot/article/6_3.png" style="height:584px; width:508px"></span>
					</p>
					<p class="text">现在已有84所一流的高校都设置了机器人工程专业，以下这些为人熟知的高校更是在2013年-2017年间就率先开设此专业，为未来的人工智能市场孕育科技人才。</p>
					<p class="text" style="text-align:center"><img alt="" src="../../../assets/img/robot/article/6_4.png" style="height:593px; width:562px"></p>
					<p class="text">机器人工程属国家新兴产业，也是教育部本科专业目录新增加专业，该专业主要面向国家智能制造发展战略和机器人科技发展趋势，培养具备扎实的机器人领域基础理论和专业知识以及较强工程实践能力，能够独立进行机器人设计、研究和创新的高素质工程技术人才。</p>
					<div class="title mt-4 mb-4" style="font-size: 20px;color: #ff8c00;">高校专业的设置折射出社会发展趋势</div>
					<p class="text">　　高校专业的设置随着时代的发展与时俱进，专业设立的变化折射出的是社会发展的趋势。近年来，人工智能技术带着众多人工智能产品，在各个行业都发挥着巨大作用，成为带动产业升级的强大推动力，极大地融入人们的工作和学习之中。</p>
					<p class="text">　　同时，人工智能技术领域的快速发展对青少年的教育教学改革也形成强大的推动力，不仅国家层面多次发声推动编程教育的发展，在今年的高考数学卷中，也涉及编程了！</p>
					<p class="text" style="text-align:center"><img alt="" src="../../../assets/img/robot/article/6_4.png" style="height:606px; width:682px"></p>
					<p class="text" style="text-align:center"><img alt="" src="../../../assets/img/robot/article/6_5.png" style="height:511px; width:682px"></p>
					<p class="text" style="text-align:center"><img alt="" src="../../../assets/img/robot/article/6_6.png" style="height:400px; width:676px"></p>
					<p class="text">　　浙江省更是率先将信息技术科目（包含编程）加入2017年高考选考科目，在《浙江省深化高校考试招生制度综合改革试点方案》中，明确将信息技术学科（含编程）纳入高中生的必学的科目，并且以100%纸笔闭卷测试的方式纳入高中阶段的考查。</p>
					<p class="text">　　孩子作为未来世界的领导者，学习编程不仅有助于升学考试，更能快速地适应人工智能时代。家长们在享受人工智能带来便利的同时，更应该具有前瞻性眼光，从小培养孩子科学兴趣和创新思维。</p>
					<div class="title mt-4 mb-3" style="font-size: 20px;color: #ff8c00;">编程改变未来</div>
					<div class="title mb-4" style="font-size: 20px;color: #ff8c00;">让孩子更好迎接人工智能时代到来</div>
					<p class="text">　　面对人工智能技术的巨大浪潮，编程教育的推广普及正当其时。</p>
					<p class="text">&nbsp;</p>
					<p style="text-align:left">原文链接：
						<a target="_blank" href="http://www.robotest.cn/article/item-257.html">http://www.robotest.cn/article/item-257.html</a>
					</p>
					<div class="clear"></div>
				</div>
			</div>
		</div>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import RobotBanner from '@/pages/robot/components/RobotBanner'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'Article6',
		components: {
			CommonHeader,
			RobotBanner,
			CommonFooter
		},
		data() {
			return {}
		},
		methods: {
			toback() {
				this.$router.push({
					path: '/robot/desc'
				})
			}
		},
		mounted() {
			document.getElementById('link1').scrollIntoView()
		}
	};
</script>

<style lang="scss" scoped>
	.content_item a {
		color: #000000;
		text-decoration: none;
	}
	
	div.title {
		font-size: 22px;
		font-weight: 600;
		text-align: center;
		letter-spacing: 2px;
	}
	
	p.tag {
		font-size: 20px;
		font-weight: 600;
		margin-top: 30px;
	}
	
	p.text {
		font-size: 16px;
		line-height: 30px;
		letter-spacing: 1px;
	}
	
	div.tips {
		border-bottom: 3px solid #F0F0F0;
		a {
			font-size: 24px;
			font-weight: 600;
			color: #333;
			text-decoration: none;
			cursor: pointer;
			letter-spacing: 2px;
			&:hover {
				color: #f39c12;
			}
		}
		.s1 {
			padding: 0 15px;
		}
		.s2 {
			letter-spacing: 2px;
			font-size: 18px;
		}
	}
</style>